enum LogLevel {
  Information = "Information",
  Error = "Error"
}

export default LogLevel;
